import type { InstallSmsIntegrationInput, SmsIntegration, SmsProviderSummary, UpdateSmsIntegrationInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

const json = (body: unknown) => JSON.stringify(body);

export function listSmsProviders(): Promise<SmsProviderSummary[]> {
  return api<SmsProviderSummary[]>('/sms/providers');
}

/** At most one installation per shipped provider, so the API returns them all, unpaged. */
export function listSmsIntegrations(): Promise<SmsIntegration[]> {
  return api<SmsIntegration[]>('/sms/integrations');
}

export function getSmsIntegration(id: string): Promise<SmsIntegration> {
  return api<SmsIntegration>(`/sms/integrations/${id}`);
}

export function installSmsIntegration(input: InstallSmsIntegrationInput): Promise<SmsIntegration> {
  return api<SmsIntegration>('/sms/integrations', { method: 'POST', body: json(input) });
}

export function updateSmsIntegration(id: string, input: UpdateSmsIntegrationInput): Promise<SmsIntegration> {
  return api<SmsIntegration>(`/sms/integrations/${id}`, { method: 'PATCH', body: json(input) });
}

export function sendSmsTest(id: string, to: string): Promise<SmsIntegration> {
  return api<SmsIntegration>(`/sms/integrations/${id}/test`, { method: 'POST', body: json({ to }) });
}

export function startSmsSending(id: string): Promise<SmsIntegration> {
  return api<SmsIntegration>(`/sms/integrations/${id}/start-sending`, { method: 'POST' });
}

export function stopSmsSending(id: string): Promise<SmsIntegration> {
  return api<SmsIntegration>(`/sms/integrations/${id}/stop-sending`, { method: 'POST' });
}

export function uninstallSmsIntegration(id: string): Promise<void> {
  return api<void>(`/sms/integrations/${id}`, { method: 'DELETE' });
}
